import { useMutation } from "react-query";
import { useAppContext } from "../AppProviders";
import { API_URL, buildMockPromise, isMocksEnabled } from "./helpers";
import { WorkflowRunExPage, WorkflowRunExPageRequest } from "./Workflows";

export function useGetWorkflowsIQA() {
  const url = `${API_URL}/workflowruns/iqa`;
  const { requestApi } = useAppContext();
  const getWorkflowsIQA = async (
    search: string,
    page: number,
    page_size: number
  ): Promise<WorkflowRunExPage> => {
    if (isMocksEnabled()) {
      return await buildMockPromise<WorkflowRunExPage>([
        [
          { payload: { full_name: "Person A", report_uuid: "safsdfasdfa" } },
          { payload: { full_name: "Person B", report_uuid: "sklfj slkj" } },
          { payload: { full_name: "Person C", report_uuid: "lskjdf s" } },
          { payload: { full_name: "Person D", report_uuid: "824hfwfn" } },
          { payload: { full_name: "Person E", report_uuid: "250h3g08gh" } },
          { payload: { full_name: "Person F", report_uuid: "2h0g2g208hg" } },
        ],
        6,
      ]);
    }
    return requestApi
      .get(`${url}?q=${search}&page=${page}&page_size=${page_size}`)
      .then((response) => {
        return response.data;
      });
  };
  const mutationResult = useMutation(
    (input: WorkflowRunExPageRequest) =>
      getWorkflowsIQA(
        input.search || "",
        input.page || 0,
        input.page_size || 20
      ),
    {}
  );
  return { ...mutationResult };
}

export function useGetWorkflowsCQA() {
  const url = `${API_URL}/workflowruns/cqa`;
  const { requestApi } = useAppContext();
  const getWorkflowsCQA = async (
    search: string,
    page: number,
    page_size: number,
    individual: boolean
  ): Promise<WorkflowRunExPage> => {
    return requestApi
      .get(
        `${url}?q=${search}&page=${page}&page_size=${page_size}&individual=${
          individual ? "1" : "0"
        }`
      )
      .then((response) => {
        return response.data;
      });
  };
  const mutationResult = useMutation(
    (input: WorkflowRunExPageRequest) =>
      getWorkflowsCQA(
        input.search || "",
        input.page || 0,
        input.page_size || 20,
        input.individual || false
      ),
    {}
  );
  return { ...mutationResult };
}
